import React, {Suspense} from 'react';
import SpinnerCustom from "@ui/spinner/SpinnerCustom";
import PageLayout from "@view/layout/pageLayout/PageLayout";
import {
    ReportDevicePlanningExecutionLazy
} from "@containers/reports/readyReports/reportDevicePlanningExecution/ReportDevicePlanningExecution.lazy";


const ReportDevicePlanningExecutionPage = () => {
    return (
        <PageLayout>
            <Suspense
                fallback={<SpinnerCustom/>}
            >
                <ReportDevicePlanningExecutionLazy/>
            </Suspense>
        </PageLayout>
    );
};

export default ReportDevicePlanningExecutionPage;